<script>
  import { router } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import FilterBar from '../../components/filter_bar.svelte'
  import FilterCheckbox from '../../components/filter_checkbox.svelte'
  import FilterDate from '../../components/filter_date.svelte'
  import FilterField from '../../components/filter_field.svelte'
  import EntityList from '../../components/entity/entity_list.svelte'
  import { Button } from '../../components/ui'
  import { confirm } from '../../components/confirm.js'
  import ActionToast from '../../components/quest_submissions/action_toast.svelte'
  import { copyShareLink } from '../../lib/clipboard.js'

  let { quest_templates = [], total_count = 0, filters = {}, date_nav = {}, new_path = '/quests/new' } = $props()

  const filterParams = () => {
    const values = {}
    if (filters.date) {
      values.date = filters.date
      if (filters.show_visible) values.show_visible = filters.show_visible
      if (filters.show_active) values.show_active = filters.show_active
    }
    if (filters.active_only) values.active_only = filters.active_only
    return values
  }

  const applyFilters = (changes) => {
    router.get('/quests', { ...filterParams(), ...changes, ...(changes.date === '' ? { date: undefined, show_visible: undefined, show_active: undefined } : {}) }, {
      preserveState: true,
      preserveScroll: true
    })
  }

  // The server hands over the day before / after the filter date.
  const shiftDate = (days) => {
    const date = days < 0 ? date_nav.previous : date_nav.next
    if (date) applyFilters({ date })
  }

  const toggleActive = (item, active) => {
    router.patch(`/quests/${item.id}`, { quest_template: { active } }, { preserveScroll: true })
  }

  let toast = $state(null)

  const copyLink = async (item) => (toast = await copyShareLink(item.current_quest?.share_url))

  const archive = async (item) => {
    const confirmed = await confirm({
      title: 'Confirm Archive',
      variant: 'error',
      body: 'Archiving is permanent unless reversed by a developer. Are you sure?'
    })
    if (!confirmed) return
    router.delete(`/quests/${item.id}`, { preserveScroll: true })
  }

  // The server works out which row moved and where it lands (AdminSite::RankedReorder).
  const onReorder = (newItems) => {
    router.patch('/quests/reorder', { ordered_ids: newItems.map((item) => item.id) }, { preserveScroll: true })
  }
</script>

<Layout>
  <PageHeader title="Quests" subtitle="Weekly capture challenges — drag to reorder" count={quest_templates.length} total={total_count}>
    {#snippet actions()}
      <Button href={new_path} variant="primary" size="sm" icon="add">New Quest</Button>
    {/snippet}
  </PageHeader>

  <FilterBar>
    {#snippet start()}
      <FilterDate
        nav
        id="quest-filter-date"
        value={filters.date || ''}
        onchange={(v) => applyFilters({ date: v })}
        onshift={shiftDate}
      />

      <FilterField label="Schedule">
        <div class="flex items-center gap-4 h-8">
          <FilterCheckbox plain label="Visible" disabled={!filters.date} title={filters.date ? undefined : 'Pick a date first'} checked={filters.show_visible} onchange={(v) => applyFilters({ show_visible: v || undefined })} />
          <FilterCheckbox plain label="Running" disabled={!filters.date} title={filters.date ? undefined : 'Pick a date first'} checked={filters.show_active} onchange={(v) => applyFilters({ show_active: v || undefined })} />
        </div>
      </FilterField>

      <FilterCheckbox label="Active" checked={filters.active_only} onchange={(v) => applyFilters({ active_only: v || undefined })} />
    {/snippet}
  </FilterBar>

  <EntityList entity="quest" rows={quest_templates} dragEnabled onreorder={onReorder} onToggle={toggleActive}>
    {#snippet actions(item)}
      <Button href={item.edit_url} variant="ghost" size="xs" square icon="edit" title="Edit" aria-label="Edit" />
      <Button href={item.duplicate_path} variant="ghost" size="xs" square icon="duplicate" title="Duplicate" aria-label="Duplicate" />
      <Button
        variant="ghost"
        size="xs"
        square
        icon="link"
        title={item.current_quest?.share_title ?? 'No upcoming occurrence to link to'}
        aria-label="Copy share link"
        disabled={!item.current_quest?.share_url}
        onclick={() => copyLink(item)}
      />
      <Button variant="ghost" size="xs" square icon="delete" class="text-error" title="Archive" aria-label="Archive" onclick={() => archive(item)} />
    {/snippet}
  </EntityList>

  <ActionToast {toast} ondismiss={() => (toast = null)} />
</Layout>
